<template>
  <div>
    <v-btn @click="drawer = true" icon color="primary">
      <v-icon>add_circle_outline</v-icon>
    </v-btn>
    <v-navigation-drawer
      v-model="drawer"
      temporary
      right
      app
      short
      width="369"
      class="rounded-top-left-10 rounded-bottom-left-10"
    >
      <v-list-item class="primary px-2">
        <v-list-item-content class="py-2">
          <v-col class="pa-0">
            <v-btn dark icon @click="drawer = !drawer">
              <v-icon style="font-size: 24px !important">close</v-icon>
            </v-btn>
            <span
              class="white--text fs-14 lh-24 font-weight-bold vertical-align-middle"
            >
              Select {{ groupType ? 'Group' : 'BO' }}
            </span>
          </v-col>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="px-4">
        <v-list-item-content>
          <v-text-field
            outlined
            single-line
            rounded
            hide-details
            placeholder="Search"
            prepend-inner-icon="search"
            class="py-0 dashSearch"
            v-model="search"
          ></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
      <v-list-item class="px-4">
        <v-list-item-content>
          <v-row class="px-3">
            <span class="font-weight-400 fs-16 pt-2">
              List {{ groupType ? 'Group' : 'BO' }}
            </span>
            <v-spacer />
            <v-btn
              v-if="groupType"
              class="primary text-capitalize f-14 lh-17"
              @click="isAdd = true"
            >
              <v-icon left>add</v-icon> Add Group
            </v-btn>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      <!-- add group -->
      <v-list-item class="px-4 border-b-1 border-t-1" v-if="isAdd">
        <v-list-item-content class="pb-0">
          <v-list-item-title
            class="f-14 lh-17 font-weight-normal mb-1 lightblack--text"
          >
            <v-row>
              <v-col class="py-0">
                Add Group
              </v-col>
              <v-spacer />
              <v-col cols="auto" class="py-0">
                <v-icon @click="close">close</v-icon>
              </v-col>
            </v-row>
          </v-list-item-title>
          <v-flex xs12 class="pa-0 mt-1">
            <ValidationObserver ref="group">
              <v-form @submit.prevent="save" class="pa-0">
                <v-row>
                  <v-col class="py-0">
                    <ValidationProvider
                      name="Group Name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        outlined
                        single-line
                        placeholder="Group Name"
                        dense
                        v-model="groupName"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="auto" class="py-0 pt-1">
                    <v-btn dark color="blue darken-3" type="submit">save</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-flex>
        </v-list-item-content>
      </v-list-item>
      <!-- list group -->
      <v-perfect-scroll
        class="drawer-group--scroll"
        :settings="scrollGroupSettings"
      >
        <v-list dense class="pt-0">
          <v-list-item v-if="itemList.length === 0">
            <v-list-item-title class="text-center pt-3">
              No group found.
            </v-list-item-title>
          </v-list-item>
          <!-- @click="redirectApproval(item)" -->
          <!-- :disabled="item.read && item.type_field !== 'APPROVAL'" -->
          <v-list-item
            v-else
            v-for="item in itemList"
            :key="item.id"
            class="border-b-1"
            @click="postGroup(item)"
          >
            <!-- <v-list-item-icon>
          </v-list-item-icon> -->
            <v-list-item-content>
              <v-row>
                <v-col
                  cols="auto"
                  class="f-14 lh-17 font-weight-normal mb-1 py-0 pt-2"
                >
                  {{ item.name }}
                </v-col>
                <v-spacer />
                <v-col cols="auto" class="py-0" v-if="item.isNew">
                  <v-btn id="btn-delete" icon @click="deleteItem(item.id)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-perfect-scroll>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    groupType: {
      type: Boolean
    }
  },
  data() {
    return {
      search: '',
      isAdd: false,
      groups: [],
      budgetowners: [],
      loading: false,
      drawer: false,
      scrollGroupSettings: {
        maxScrollbarLength: 500
      },
      groupName: '',
      timeouts: null
    };
  },
  watch: {
    search() {
      clearTimeout(this.timeouts);
      this.timeouts = setTimeout(() => {
        this.groupType ? this.getGroup() : this.getBO();
      }, 1000);
    },
    drawer(val) {
      if (val) {
        this.groupType ? this.getGroup() : this.getBO();
      }
    }
  },
  computed: {
    itemList() {
      return this.groupType ? this.groups : this.budgetowners;
    }
  },
  mounted() {
    // this.getGroup();
    // this.getBO();
  },
  methods: {
    getGroup() {
      this.loading = true;
      let params = {
        division_id: Number(this.$route.params.id),
        search: { name: this.search }
      };
      return this.$store
        .dispatch('dynamic/getGroup', params)
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.groups = data.data.map(itemgroup => {
              return {
                ...itemgroup,
                isNew: false
              };
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.loading = false;
        });
    },
    getBO() {
      let params = {
        division_id: Number(this.$route.params.id),
        search: { desc: this.search }
      };
      this.loading = true;
      return this.$store
        .dispatch('dynamic/getBO', params)
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.budgetowners = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.loading = false;
        });
    },
    async save() {
      const validated = await this.$refs.group.validate();
      if (validated) {
        this.loading = true;
        this.$store
          .dispatch('dynamic/createGroup', { name: this.groupName })
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              let tempCreate = data.data;
              tempCreate.isNew = true;
              let tempGroup = [tempCreate].concat(this.groups);
              this.groups = tempGroup;
              Swal.fire('Success!', data.message.text_en, 'success');
              this.groupName = '';
              this.close();
              // this.getGroup();
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.loading = false;
            Swal.fire('Failed!', err.response.data.data.error, 'error');
          });
      }
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this group!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.loading = true;
          this.$store.dispatch('dynamic/deleteGroup', id).then(data => {
            this.loading = false;
            Swal.fire('Deleted!', data.message.text_en, 'success');
            this.getGroup();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your division data has been undeleted',
            'error'
          );
        }
      });
    },
    close() {
      this.isAdd = false;
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    postGroup(item) {
      this.$emit('setGroup', item);
    }
  }
};
</script>
<style>
.drawer-group--scroll {
  max-height: 540px;
  overflow: auto;
}
</style>
